import { TimelineLite } from 'gsap/TweenMax';
import { throttle, debounce } from 'throttle-debounce';
import { DOM, CLASSES, GLOBAL } from "../helpers/_global";

const mobDropClass = 'js-dropdown-mob-parent';

export default class Header {
  constructor() {
    this.contentSelector='.js-cmp-out';
    this.$elContent = $(this.contentSelector);
    this.selector = '.js-cmp-header';
    this.$el = $(this.selector);
    this.height = this.$el.innerHeight();
    this.isScrollingUp = false;
    this.lastScrollTop = 0;
    this.DROP_BG_HEIGHT = 400;
    this.DROP_BG_WIDTH = 520;
    this.dropTl = 0;
    this.prevHoverLink = 0;
    this.doubleTouchTimer = 0;
    this.hideTimeout = 0;
    this.showTimeout = 0;
    this.mobNavIsOpen = false;
    this.isFixedState = false;
    this.windowScrollPos = 0;
    this.CLASSES = {
      transition: 'is-transition',
      left: 'is-left',
      right: 'is-right',
      hasOverlay: 'has-overlay'
    };

    this.getElements();
  }

  init() {
    if (!this.$el[0]) return;

    if (!GLOBAL.isTouch) {
      this.detectHoverOnLoad();
    }
    this.setEvents();
  }

  getElements() {
    this.$menu = this.$el.find('.js-cmp-header-menu');
    this.$menuLinks = this.$el.find('.js-cmp-header-link.is-dropdown');
    this.$dropLine = this.$el.find('.js-cmp-header-drop-line');
    this.$dropBg = this.$el.find('.js-cmp-header-drop-bg');
    this.$dropWrapper = this.$el.find('.js-cmp-header-drop-wrapper');
    this.$dropContent = this.$el.find('.js-cmp-header-drop-content');
    this.$dropSection = this.$el.find('.js-cmp-header-drop-section');
    this.$burger = this.$el.find('.js-cmp-header-burger');
    this.$mobMenu = $('.js-cmp-header-mob-menu');
    this.$mobMenuOverlay = this.$mobMenu.find('.js-cmp-header-mob-menu-overlay');
    this.$mobDropLink = this.$mobMenu.find('.js-dropdown-mob-link');
    this.$mobDrop = this.$mobMenu.find(`.${mobDropClass}`);
  }

  setEvents() {

    if (!GLOBAL.isTouch) {
      this.$el.mouseenter(this.headerMouseenterHandle.bind(this));
      this.$el.mouseleave(this.headerMouseleaveHandle.bind(this));
      this.$menuLinks.mouseenter(this.navLinkMouseEnterHandle.bind(this));
      this.$menuLinks.mouseleave(this.navLinkMouseLeaveHandle.bind(this));
      this.$dropSection.mouseenter(this.clearHideTimeout.bind(this));
      this.$dropSection.mouseleave(this.setHideTimeout.bind(this));
    }

    if (GLOBAL.isTouch) {
      this.$menuLinks.on('click', this.navLinkClickHandle.bind(this))
    }

    DOM.$window.on('resize', debounce(350, this.resizeHandle.bind(this)));
    setTimeout(() => {
      DOM.$window.on('scroll', throttle(50, this.scrollHandle.bind(this)));
    }, 200);

    this.$burger.on('click', this.burgerHandle.bind(this));
    this.$mobMenuOverlay.on('click', this.closeMobmenu.bind(this));
    this.$mobDropLink.on('click', this.mobDropHandle.bind(this));
  }

  mobDropHandle(e){
    e.preventDefault();
    const $link = $(e.currentTarget);
    const $parent = $link.parents(`.${mobDropClass}`);
    this.$mobDrop.removeClass(CLASSES.active);
    $parent.addClass(CLASSES.active);

    if (!this.doubleClickDetect()) return;
    document.location.href = $link.attr('href');
  }

  burgerHandle(){
    if (this.mobNavIsOpen === false){
      this.mobNavIsOpen = true;
      this.$mobMenu.addClass(CLASSES.active);
      this.windowScrollPos = DOM.$window.scrollTop();
      DOM.$window.scrollTop(0);
      DOM.$body.addClass(CLASSES.menuOpened);
    } else {
      this.closeMobmenu();
    }
  }

  closeMobmenu() {
    this.mobNavIsOpen = false;
    DOM.$body.removeClass(CLASSES.menuOpened);
    DOM.$window.scrollTop(this.windowScrollPos);
    this.$mobMenu.removeClass(CLASSES.active);
    this.isScrollingUp = false;
    this.$mobDrop.removeClass(CLASSES.active);
    this.$mobMenu.scrollTop(0);
    this.headerMouseleaveHandle();
  }

  navLinkClickHandle(e) {
    e.preventDefault();
    if (!this.doubleClickDetect()) return;
    document.location.href = $(e.currentTarget).attr('href');
  }

  doubleClickDetect() {
    const now = new Date().getTime();
    const timesince = now - this.doubleTouchTimer;
    const maxDoubleTouchTime = 300;
    const isDouble = !!((timesince < maxDoubleTouchTime) && (timesince > 0));
    this.doubleTouchTimer = new Date().getTime();
    return isDouble;
  }

  navLinkMouseEnterHandle(e) {
    const $link = $(e.currentTarget);
    this.clearHideTimeout();
    const linkType = $link.data('dropdown');
    this.$menu.addClass('is-dropdown-visible');
    this.$nextDropSection = this.$dropSection.filter(`[data-dropdown="${linkType}"]`);
    this.$nextDropSection.addClass('is-active');
    this.calcNewDropData($link);
    this.setDropPos();
    this.setLinePos();
    this.setBgPos();
    this.showDropBlock();
    this.activeHoverLinkIndex = this.$menuLinks.index($link);
  }

  navLinkMouseLeaveHandle() {
    this.setHideTimeout();
    this.$menu.removeClass('is-dropdown-visible');
  }

  calcNewDropData($link) {
    this.nextDropSectionWidth = this.$nextDropSection.innerWidth();
    this.nextDropSectionHeight = this.$nextDropSection.innerHeight();
    this.nextLinkCenter = $link.position().left + $link.innerWidth() / 2;
    this.nextDropCenter = this.nextLinkCenter - this.nextDropSectionWidth / 2;
    this.nextDropBgScaleX = this.nextDropSectionWidth / this.DROP_BG_WIDTH;
    this.nextDropBgScaleY = this.nextDropSectionHeight / this.DROP_BG_HEIGHT;
  }

  dropSectionAnim() {
    this.clearLinks();
    this.$dropSection.each((i, el) => {
      const $el = $(el);
      if (i < this.activeHoverLinkIndex) {
        $el.addClass(this.CLASSES.left);
      } else if (i === this.activeHoverLinkIndex) {
        $el.addClass(CLASSES.active);
      } else {
        $el.addClass(this.CLASSES.right);
      }
    })
  }

  clearLinks() {
    this.$dropSection.removeClass(CLASSES.active);
    this.$dropSection.removeClass(this.CLASSES.left);
    this.$dropSection.removeClass(this.CLASSES.right);
  }

  setDropPos() {
    this.$dropContent.css({
      '--dropContentTranslateX': `${this.nextDropCenter}px`,
      '--dropContentWidth': `${this.nextDropSectionWidth}px`,
      '--dropContentHeight': `${this.nextDropSectionHeight}px`
    });
  }

  setLinePos() {
    this.$dropLine.css({ '--translateDropLineX': `${this.nextLinkCenter}px` })
  }

  setBgPos() {
    this.$dropBg.css({
      '--translateDropBgX': `${this.nextDropCenter}px`,
      '--scaleDropBgX': `${this.nextDropBgScaleX}`,
      '--scaleDropBgY': `${this.nextDropBgScaleY}`
    });
  }

  showDropBlock() {
    this.dropTl = new TimelineLite();
    this.dropTl
    .to(this.$dropWrapper, 0.2, {
      onComplete: () => {

      },
      onStart: () => {
        this.dropSectionAnim();
        this.$dropWrapper.addClass(this.CLASSES.transition);
        this.$elContent.addClass(this.CLASSES.hasOverlay);
      }
    }, 0)
  }

  hideDropBlock() {
    this.dropTl = new TimelineLite();
    this.dropTl
    .to(this.$dropWrapper, 0.2, {
      onComplete: () => {
        this.$dropWrapper.removeClass(this.CLASSES.transition);
        this.$elContent.removeClass(this.CLASSES.hasOverlay);
        this.clearLinks()
      }
    }, 0)
  }

  setHideTimeout() {
    this.hideTimeout = setTimeout(() => {
      this.hideDropBlock();
    }, 80)
  }

  clearHideTimeout() {
    clearTimeout(this.hideTimeout);
  }

  // / header scroll and view
  setHeaderTransform() {
    if(this.mobNavIsOpen === true) return;

    if (this.isHover === true) {
      this.$el.removeClass(CLASSES.transform);
      return;
    }

    if (this.isScrollingUp === true) {
      this.$el.removeClass(CLASSES.transform);
      return;
    }


    if (DOM.$window.scrollTop() >= this.height) {

      this.$el.addClass(CLASSES.transform)
    } else {
      this.$el.removeClass(CLASSES.transform)
    }
  }

  scrollHandle() {
    const currentScrollTop = DOM.$window.scrollTop();
    this.isScrollingUp = !(currentScrollTop > this.lastScrollTop);
    this.lastScrollTop = currentScrollTop;
    this.setHeaderTransform();
  }

  detectHoverOnLoad() {
    this.isHover = !!$(`${this.selector}:hover`).length;
  }

  headerMouseenterHandle() {
    this.isHover = true;
    this.setHeaderTransform();
  }

  headerMouseleaveHandle() {
    this.isHover = false;
    this.setHeaderTransform();
  }

  resizeHandle() {
    this.height = this.$el.innerHeight();
    this.setHeaderTransform();

    if(this.mobNavIsOpen === true){
      this.mobNavIsOpen = false;
      DOM.$body.removeClass(CLASSES.menuOpened)
      DOM.$window.scrollTop(this.windowScrollPos);
      this.$mobMenu.removeClass(CLASSES.active);
      // this.isScrollingUp = false;
      this.$mobDrop.removeClass(CLASSES.active);
      this.$mobMenu.scrollTop(0);

    }

  }


}

// TODO
// 1. * when all pages will  moved to a new template, maybe, will be better replace setTimeout for scroll in setEvents() to window.load
